<template>
  <div class="page">
    <img class="banner" src="@/modules/interview/images/banner1.png">
    <!-- 顶部步骤-->
    <process :process-val="2" />
    <div class="main">
      <div class="content-box">
        <div class="tips" />
        <div class="select-title">选择面试时间</div>
        <div class="select-hint">*若时间都不合适，请和小助手约其他时间</div>
        <div class="select-date" @click="showTimePopup = true">
          <div>{{ currentDate }}</div>
          <van-icon name="arrow-down" />
        </div>
        <div class="select-period">
          <div :class="['period-item', timeType == 1 ? 'sel' : '']" @click="switchType(1)">上午</div>
          <div :class="['period-item', timeType == 2 ? 'sel' : '']" @click="switchType(2)">下午</div>
        </div>
        <van-radio-group v-if="timeList.length > 0" v-model="timeSelect" class="time-list">
          <van-radio v-for="(item, index) in timeList" :key="index" :name="item.btime_id" class="time-item" :disabled="item.is_busy == 1">
            <template #icon="props">
              <span :class="['item-val', props.checked ? 'item-sel' : '', item.is_busy == 1 ? 'item-gray' : '']">{{ item.start_time | timeF }}-{{ item.end_time | timeF }}</span>
            </template>
          </van-radio>
        </van-radio-group>
        <div v-else class="list-null">当前暂无可预约时间段<br>请选择其他日期</div>
        <div v-if="timeList.length > 0 && !isSubmitMake" class="submit-btn" @click="checkPhone">预约此时间段</div>
        <div v-else-if="timeList.length > 0 && isSubmitMake" class="submit-btn">正在预约中..</div>
      </div>
      <div class="bottom-logo">
        <img src="@/modules/interview/images/logo.png" class="logo-path">
      </div>
    </div>
    <van-popup v-model="showTimePopup" position="bottom">
      <van-datetime-picker type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate" :formatter="formatter" @cancel="showTimePopup = false" @confirm="confirmDate" />
    </van-popup>
  </div>
</template>

<script>
import { Button, RadioGroup, Radio, Icon, DatetimePicker, Popup, Toast, Dialog } from 'vant'
import { getUrlKey, dateToStr } from '@/utils/index'
import { interviewerTimes, interviewAdd } from '@/api/interview'
import { getLogin } from '@/utils/auth' // 获取auth参数
import process from '../components/process'

export default {
  name: 'Result',
  components: {
    [RadioGroup.name]: RadioGroup,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [DatetimePicker.name]: DatetimePicker,
    [Radio.name]: Radio,
    [Popup.name]: Popup,
    process
  },
  filters: {
    timeF(val) {
      return val.substr(0, 5)
    }
  },
  data: function() {
    return {
      timeType: 1,
      showTimePopup: false,
      timeSelect: [],
      timeList: [],
      minDate: new Date(),
      maxDate: new Date(2022, 1, 4), // 暂时改成2月4日
      currentDate: '',
      isSubmitMake: false
    }
  },
  created() {
    var maxDate = new Date()
    var minDate = new Date()
    maxDate.setDate(maxDate.getDate() + 3)
    minDate.setDate(minDate.getDate() + 1)
    this.maxDate = maxDate
    this.minDate = minDate
    this.currentDate = dateToStr(minDate, 'yyyy-MM-dd')
    this.getTimeData()
  },
  methods: {
    getTimeData() {
      interviewerTimes({
        open_id: getLogin(),
        interview_date: this.currentDate,
        time_type: this.timeType
      }).then(res => {
        if (res.data.code === 200) {
          console.log('可开放时间', res.data.data.list)
          var list = res.data.data.list
          var arr = []
          for (var i = 0; i < list.length; i++) {
            // if (list[i].interviewer_count > 0) {
            if (list[i].interviewer_count > 0 && list[i].btime_id >= 17) { // 暂时关闭凌晨的时间
              arr.unshift(list[i])
            }
          }
          this.timeList = arr.reverse()
        } else {
          this.$sentry.captureMessage('selectTime', { level: 'info', tags: 'getTime', extra: { context: '获取时间失败' + this.currentDate }})
          Toast.fail(res.data.data)
        }
      })
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      } else if (type === 'day') {
        return `${val}日`
      }
      return val
    },
    confirmDate(e) {
      this.currentDate = dateToStr(e, 'yyyy-MM-dd')
      this.timeSelect = ''
      this.showTimePopup = false
      this.getTimeData()
    },
    switchType(type) {
      if (type !== this.timeType) {
        this.timeType = type
        this.timeSelect = ''
        this.getTimeData()
      }
    },
    // 获取手机号
    checkPhone() {
      if (sessionStorage.getItem('userPhone')) {
        this.phone = sessionStorage.getItem('userPhone')
        this.submitMake()
      } else {
        Dialog.alert({
          title: '温馨提示',
          message: '系统未检测到您的手机号，请前往绑定'
        }).then(() => {
          this.$router.replace('/') // 返回首页
        })
      }
    },
    // 点击提交按钮
    submitMake() {
      if (!this.isSubmitMake) {
        this.isSubmitMake = true
        interviewAdd({
          open_id: getLogin(),
          interview_date: this.currentDate,
          btime_id: this.timeSelect,
          channel: getUrlKey('income'),
          user_phone: this.phone
        }).then(res => {
          if (res.data.code === 200) {
            Toast.fail('预约成功')
            this.goto('/interviewer')
          } else if (res.data.code === 3626) {
            Toast.fail('请勿重复预约, 若有疑问请联系客服～')
            this.goto('/interviewer')
          } else {
            this.isSubmitMake = false
            this.getTimeData()
            this.timeSelect = ''
            Toast.fail('预约失败, 请重试')
          }
        })
      }
    },
    goto(path) {
      this.$router.replace(path)
    }
  }
}
</script>

<style lang="less" scoped>
  .page{
    position: relative;
    width: 375px;
    padding-top: 20px;
    .banner{
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
    }
    .main{
      position: relative;
      z-index: 1;
      width: 300px;
      margin: 80px auto 0 auto;
      padding-bottom: 20px;
      .content-box{
        border-radius: 10px 10px 0 10px;
        background: #fff;
        padding: 10px 25px 30px 25px;
      }
      .select-title{
        text-align: center;
        height: 50px;
        line-height: 65px;
        color: #ee5030;
        font-weight: bold;
        font-size: 20px;
        border-bottom: 1px solid #666;
      }
      .select-hint{
        font-size: 12px;
        color: #999999;
        text-align: center;
        line-height: 30px;
      }
      .select-date{
        background: #eaeaea;
        height: 24px;
        line-height: 24px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 5px 15px;
        margin-top: 15px;
        font-size: 14px;
        text-align: center;
      }
      .select-period{
        border-radius: 5px;
        display: flex;
        align-items: center;
        overflow: hidden;
        margin-top: 20px;
        .period-item{
          height: 30px;
          line-height: 30px;
          text-align: center;
          width: 50%;
          background: #eaeaea;
          color: #666;
          font-size: 16px;
          &.sel{
            background: #ee5030;
            color: #fff;
          }
        }
      }
      .time-list{
        padding-top: 20px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .time-item{
          width: 76px;
          height: 26px;
          margin: 5px 3px;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          overflow: hidden;
          border-radius: 5px;
          .item-val{
            width: 72px;
            height: 23px;
            line-height: 23px;
            display: block;
            margin: 0 auto;
            font-size: 10px;
            text-align: center;
            border: 1px solid #666;
            color: #666;
            border-radius: 5px;
            &.item-sel{
              position: relative;
              border: 1px solid #ee5030;
              color: #ee5030;
              &:before{
                content: '✓';
                position: absolute;
                width: 20px;
                height: 20px;
                line-height: 29px;
                padding-left: 3px;
                text-align: left;
                border-radius: 50%;
                right: -10px;
                top: -10px;
                background: #ee5030;
                color: #fff;
                font-size: 8px;
              }
            }
            &.item-gray{
              background: #eaeaea;
              border: 1px solid #eaeaea;
              color: #666;
            }
          }
        }
      }
      .list-null{
        height: 100px;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #999;
      }
      .submit-btn{
        border: 1px solid #333;
        background: #fff;
        text-align: center;
        height: 38px;
        line-height: 38px;
        border-radius: 4px;
        font-weight: bold;
        color: #333;
        font-size: 18px;
        margin: 20px auto;
      }
      .tips{
        width: 130px;
        height: 30px;
        background: url("../images/tips.png") no-repeat;
        background-size: contain;
      }
    }
  }
  .bottom-logo{
    border-radius: 0 0 10px 0;
    background: #fff;
    width: 60%;
    margin-left: 40%;
    padding-bottom: 10px;
    position: relative;
    &:before{
      content: '';
      font-size:0;
      border-style:solid;
      overflow:hidden;
      position:absolute;
      border-width:45px;
      border-color: transparent #fff transparent transparent;
      left:-90px;
      bottom:0;
      z-index: -1;
    }
    .logo-path{
      width: 90%;
    }
  }
</style>

